import React from 'react';

import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';

const useActiveOnRegions = (...regions: string[]) => {
  const {
    tokens: { region },
  } = useAuthenticationTokens();

  return React.useMemo(() => regions.find((r) => r === region), [
    region,
    regions,
  ]);
};

export default useActiveOnRegions;
